import angular from 'angular';
import eventBus from 'pubsub-js';

angular.module('cloudX').directive('cxDashboardOwnCompanySelector', [
  function() {
    return {
      restrict: 'E',
      template: require('./dashboardOwnCompanySelector.html'),
      scope: { target: '@' },
      controller: [
        '$scope',
        'dashboardSvc',
        'dataCache',
        function($scope, dashboardSvc, dataCache) {
          $scope.companies = [];
          $scope.selectedCompany = {};

          dataCache.ready().then(() => {
            $scope.companies = dataCache.getArray('company');
            $scope.selectedCompany = $scope.companies.find(
              x => x.id == dataCache.getDefaultCompany().id,
            );
          });

          $scope.companyChanged = function(company) {
            Promise.all([
              dashboardSvc.reloadTopCustomerDebt(company.id),
              dashboardSvc.reloadBilledPerMonth(company.id),
              dashboardSvc.reloadTopCustomerRevenue(company.id),
              dashboardSvc.reloadComplianceStatistics(company.id),
            ]).then(function() {
              eventBus.publish('dashboardOwnCompanyChanged');
            });
          };
        },
      ],
    };
  },
]);
